import FoodOrderingCart from "pages/guest/Customer/ClientPortal/FoodOrdering/ClientPortalFoodOrderingCart";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as CustomerCartActions from "redux/actions/customer/cart";
import * as UIActions from "redux/actions/ui";

const mapStateToProps = (state: any) => {
  return {
    cartStore: { ...state.customerCartStore },
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    cartActions: bindActionCreators(
      {
        ...CustomerCartActions,
      },
      dispatch,
    ),
    uiActions: bindActionCreators(
      {
        ...UIActions,
      },
      dispatch,
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FoodOrderingCart);
